import React, {useState} from 'react';
import {Form, Input, Checkbox, Button, Radio, Switch, Select} from 'antd';
import styles from './layout.module.less'
import NumberInput from "../../../components/NumberInput";
import store from "../store";
import projectStore from "../../user/project/store";
import {observer} from 'mobx-react';
// import moment from "moment";
import lodash from 'lodash'
import deletePng from './delete.png';


// the hook
import {useTranslation} from 'react-i18next';

export default observer(function (props) {
  const {t, i18n} = useTranslation();
  const {record, index} = props
  const {selectedCustomKeys} = store
  const [formRef] = useState(React.createRef())
  // const [isMeasure, setIsMeasure] = useState(record['is_measure'])
  const [uid] = useState((new Date()).getTime() + Math.random())
  const delRow = () => {
    // if (record.id) {
    //   store.delRecord(record.id, index, true)
    // } else if (store.userAddRecords.length>1) {
    //   store.userAddRecords.splice(index, 1)
    // } 
    store.userAddRecords.splice(index, 1)
  }

  // const onRadioClick = () => {
  //   formRef.current.setFieldsValue({
  //     is_measure: !isMeasure,
  //   });
  //   setIsMeasure(!isMeasure)
  // }

  function updateRecord(value) {
    Object.assign(record, value)
    store.updateUserAddRecord(record, index)
  }

  const onFinish = (data) => {
    store.updateUserAddRecord(data, index)
  }

  // const disabledDate = (current) => {
  //   return current < moment().subtract(1, 'days')
  // }

  const handleCheck = (e, id) => {
    if (e.target.checked && selectedCustomKeys.indexOf(id) === -1) {
      selectedCustomKeys.push(id)
    }
    if (!e.target.checked) {
      lodash.remove(selectedCustomKeys, v => v === id)
    }
  }

  return (
    <React.Fragment>
      <Form className={[styles.formRow, 'reset-disabled-input', styles.formRowEdit].join(" ")}
            key={record.id ? record.id : uid}
            initialValues={record}
            name={record.id ? record.id : uid}
            layout="inline"
            ref={formRef}>

        {/* <Form.Item valuePropName="checked" name='checked' className={styles.td1}>
          <Checkbox disabled={!record.id} onChange={(e) => {
            handleCheck(e, record.id)
          }}/>
        </Form.Item> */}

        <Form.Item valuePropName="checked" name="catalog"
                   className={[i18n.language === 'en' ? styles.autoWidth : ''].join(" ")}>
          {/* <Switch checkedChildren={t("购")} unCheckedChildren={t("租")} defaultChecked={true}/> */}
          <Select
            className='cart_select'
            placeholder="请选择类型" value={record.catalog} onChange={v => updateRecord({ catalog: v })}>
            {/* {gStore.catalogList?.map(item => (
            <Select.Option key={item?.code} value={item?.code} item={item}>
              {item?.name}
            </Select.Option>
                ))} */}
            <Select.Option key={1} value="Rent">
              租赁
            </Select.Option>
            <Select.Option key={2} value="Sale">
              采购
            </Select.Option>
            <Select.Option key={3} value="Testing">
              计量
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="name" rules={[{required: true, message: t('请输入品名')}]}>
          <Input autoComplete="off" 
            className='cart_input' 
            size="large" 
            placeholder={t('请输入品名，必填')}
            onChange={e => updateRecord({ name: e.target.value })}
          />
        </Form.Item>

        <Form.Item name="brand">
          <Input autoComplete="off" 
            className='cart_input' 
            size="large" 
            placeholder={t('请输入品牌')}
            onChange={e => updateRecord({ brand: e.target.value })}
          />
        </Form.Item>

        <Form.Item name="formats" rules={[{required: true, message: t('请输入规格')}]}>
          <Input autoComplete="off" 
            className='cart_input' 
            size="large" 
            placeholder={t('请输入规格，必填')}
            onChange={e => updateRecord({ formats: e.target.value })}
          />
        </Form.Item>

        <Form.Item name="factoryCode">
          <Input autoComplete="off" 
            className='cart_input' 
            size="large" 
            placeholder={t('请输入货号')}
            onChange={e => updateRecord({ factoryCode: e.target.value })}
          />
        </Form.Item>

        <Form.Item name="cartRemarks">
          <Input autoComplete="off" 
            className='cart_input' 
            size="large" 
            placeholder={t('其他需求请备注限50字')}
            onChange={e => updateRecord({ cartRemarks: e.target.value })}
          />
        </Form.Item>

        {/* <Form.Item name="desc" className={styles.td7}>
          <Input autoComplete="off" placeholder={t('产品说明')}/>
        </Form.Item> */}

        <Form.Item name="number">
          <NumberInput 
            className="inputNum" 
            min={1} 
            max={999}
            onChange={v => updateRecord({ number: v })}
          />
        </Form.Item>
        <Form.Item>
          <div className={styles.rowBtn}>
            {/* <Button size={'small'} type={'primary'} htmlType="submit">{t('保存')}</Button> */}
            {
                <div onClick={() => delRow()} className={styles.del}>
                  {/* <img src={delImg} alt="" /> */}
                  <img src={deletePng} alt="" style={{"cursor": "pointer",'width':'16px'}} />
                </div>
            }

          </div>

        </Form.Item>
      </Form>
    </React.Fragment>
  )
})
